import { UrlWsClientes } from '../config/Services'
import { dateToJson } from '../utils/DateUtil'
import { GetCall, PostCall, PutCall } from './_serviceHelper2'

const serviceUrl = UrlWsClientes()

/** @returns obj devuelto: {errores, data} */
export const listarClientes = (filters) => GetCall(serviceUrl, filters)

/** @param {String} texto nombre o apellido @returns {errores, data} */
export const autocompCliente = (texto) => GetCall(serviceUrl + '/autocompletar', { texto })

/** @returns obj devuelto: {errores, data} */
export const agregarCliente = (unCliente) => PostCall(serviceUrl, unCliente)

/** @returns obj devuelto: {errores, data} */
export const modificarCliente = (unCliente) => PutCall(serviceUrl, unCliente)

/** @returns obj devuelto: {errores, data} */
export const borrarClientes = (listaIds) => PutCall(serviceUrl + '/borrar', listaIds)

/** @returns obj devuelto: {errores, data} */
export const reactivarClientes = (listaIds) => PutCall(serviceUrl + '/reactivar', listaIds)

/** @returns lista de transacciones para el cliente seleccionado. Obj devuelto: {errores, data} */
export const listarTransacciones = (filters) => {
    var params = {
        clienteId: filters?.clienteId,
        fechaDesde: dateToJson(filters?.fechaDesde),
        fechaHasta: dateToJson(filters?.fechaHasta),
        pageNumber: filters?.pageNumber,
        pageSize: filters?.pageSize
    }
    return GetCall(serviceUrl + '/transacciones', params)
}

/**
 * @param {objTransaccion} unaTransaccion {cliente, importe, tipoTransaccion}
 * @returns obj devuelto: {errores, data}
 */
export const agregarTransaccion = (unaTransaccion) => PostCall(serviceUrl + '/transacciones', unaTransaccion)

/************ Reportes ************/

const reportUrl = serviceUrl + '/reportes'

export const reporteEstadoCtaCte = (filters) => GetCall(reportUrl+'/estadoCtaCte', {})

export const reporteDeudores = (filters) => {
    var params = {
        pageNumber: filters?.pageNumber,
        pageSize: filters?.pageSize
    }
    return GetCall(reportUrl+'/deudores', params)
}

export const reporteGastadores = (filters) => {
    var params = {
        periodo: dateToJson(filters?.periodo),
        pageNumber: filters?.pageNumber,
        pageSize: filters?.pageSize
    }
    return GetCall(reportUrl+'/gastadores', params)
}

export const reporteEvolucionClientes = (filters) => {
    var params = {
        agrupa: filters?.agrupa
    }
    return GetCall(reportUrl+'/evolucionClientes', params)
}